module.exports = __webpack_public_path__ + "static/media/right-arrow.761f2556.svg";